export default __webpack_public_path__ + "static/media/Bindings of the Forsaken.1cc99ea4.jpg";